import React from 'react';
export function Contrast({
  height = 24,
  width = 24
}: {
  height?: number;
  width?: number;
}) {
  return <svg width={`${height}px`} height={`${width}px`} viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
      <path d="M256,32C132.29,32,32,132.29,32,256S132.29,480,256,480,480,379.71,480,256,379.71,32,256,32ZM128.72,383.28A180,180,0,0,1,256,76V436A178.82,178.82,0,0,1,128.72,383.28Z" />
    </svg>;
}